import { useMemo } from "react";

import { ChevronRightIcon } from "@radix-ui/react-icons";
import { Flex, Text } from "@radix-ui/themes";
import { createColumnHelper } from "@tanstack/react-table";
import { format } from "date-fns";
import { startCase } from "lodash";

import { statusToTagColor } from "./utils";
import { ContactRequest } from "../../../api/public";
import { Tag } from "../../../common/components";

const columnHelper = createColumnHelper<ContactRequest>();

export const useContactRequestsTableColumns = () => {
  return useMemo(
    () => [
      columnHelper.accessor("submitted_at", {
        header: "Request Date",
        cell: (cell) => {
          const value = cell.getValue();
          if (!value) {
            return (
              <Flex height="100%" align="center">
                <Text size="2">-</Text>
              </Flex>
            );
          }
          const offsetValue = new Date(
            new Date(value).valueOf() +
              new Date(value).getTimezoneOffset() * 60 * 1000
          );

          return (
            <Flex height="100%" align="center">
              <Text size="2">{format(offsetValue, "MM/dd/yyy")}</Text>
            </Flex>
          );
        },
      }),
      columnHelper.accessor("raw_material", {
        header: "Product",
        cell: (cell) => {
          const raw_material = cell.getValue();
          return (
            <Flex height="100%" align="center">
              <Text size="2">
                {raw_material.trade_name}
                {` by ${raw_material.supplier_name}`}
              </Text>
            </Flex>
          );
        },
        size: 300,
        maxSize: 300,
      }),
      columnHelper.accessor("status", {
        header: "Status",
        cell: (cell) => {
          const status = cell.getValue();
          return (
            <Flex height="100%" align="center">
              <Tag size="2" color={statusToTagColor(status)}>
                {startCase(status)}
              </Tag>
            </Flex>
          );
        },
      }),
      columnHelper.display({
        id: "chevron",
        cell: () => {
          return (
            <Flex justify="center" height="100%" align="center">
              <ChevronRightIcon />
            </Flex>
          );
        },
        size: 1,
      }),
    ],

    []
  );
};
